module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default", null, {
    "setDrawingMode": _vm.setDrawingMode,
    "deleteSelection": _vm.deleteSelection
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0181c0a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/gmap-vue/dist/components/drawing-manager.vue
// module id = 1386
// module chunks = 0